const investTagPlacementDurationLang = {
	inf_3_years: {
		tag: 'invest.tag.placement_duration.inf_3_years',
		fr: '< 3 ans',
		en: '< 3 years',
	},
	'3_5_years': {
		tag: 'invest.tag.placement_duration.3_5_years',
		fr: '3 à 5 ans',
		en: '3 to 5 years',
	},
	sup_3_years: {
		tag: 'invest.tag.placement_duration.sup_3_years',
		fr: '> 3 ans',
		en: '> 3 years',
	},
	sup_5_years: {
		tag: 'invest.tag.placement_duration.sup_5_years',
		fr: '> 5 ans',
		en: '> 5 years',
	},
};

export default investTagPlacementDurationLang;
